import { AppThunk } from "../store";
import { setLogout, setUserInfo } from "../features/loginSlice";
import { setSideBars } from "../features/dashboardSlice";
import { Organization, User } from "@/types/user.types";
import { getDashboardSideBarConfig } from "@/utils/constant/dashboard.constant";
import Secure from "@/secure/payload";

export const loginSuccessAction =
  (data: { user: User; orgs: Organization[]; dataRgn: string; perms: any }): AppThunk =>
  (dispatch) => {
    const { user, orgs, dataRgn, perms } = data || {};
    if (dataRgn) {
      localStorage.setItem("data-region", dataRgn);
    }
    const decryptedUser = user ? Secure.payloadDecryption(user, { excludedKeys: ["profilePic"] }) : user;
    // console.log({ decryptedUser });
    dispatch(setUserInfo({ user: decryptedUser, orgs: orgs, perms }));

    if (decryptedUser?.userType && decryptedUser?.role && perms) {
      const { userType, role } = decryptedUser;
      const sideBars: any = getDashboardSideBarConfig({
        userType,
        userRole: role,
        perms,
        currentEmpExtId: decryptedUser?.empExtId,
        isCloneUserRole: decryptedUser?.isCloneUserRole,
      });
      // console.log("Login Actions", { sideBars });
      dispatch(setSideBars(sideBars));
    }
  };

export const logOutSuccessAction = (): AppThunk => (dispatch) => {
  dispatch(setLogout());
};
